module.exports = __webpack_public_path__ + "static/media/DSC_0021.5c35151d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0021.jpg
// module id = 677
// module chunks = 0